// Angular
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

// Ionic library
import {
  AlertController,
  IonContent,
  IonIcon,
  IonTitle,
  ModalController
} from '@ionic/angular/standalone';

// Local library
import { ReplaysAndSearchComponent } from '../replays-and-search/replays-and-search.component';
import { WagerFacade } from '@amwager/wager/data-access';
import { GUEST, IGetEventsDetailsResponse } from '@amwager/util-ts';
import { PermissionService, SessionService } from '@amwager/data-access';

// Third party
import * as _ from 'lodash';
import { Dictionary } from '@ngrx/entity';
import { AuthFacade } from '@amwager/authentication/data-access';

@Component({
  selector: 'feature-ion--results-menu',
  templateUrl: './results-menu.component.html',
  styleUrls: ['./results-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonContent,
    IonIcon,
    IonTitle,
    CommonModule,
    ReplaysAndSearchComponent
  ]
})
export class ResultsMenuComponent implements OnInit {

  cardContentHTMList!: HTMLElement[];

  controller = {
    bettingResults: false,
    replays: false,
  };

  selectedEvent!: IGetEventsDetailsResponse;

  private showAlertInfoHandler?: HTMLIonAlertElement;

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly modalCtrl: ModalController,
    private readonly elementRef: ElementRef,
    private readonly wagerFacade: WagerFacade,
    private readonly sessionService: SessionService,
    private readonly permissionService: PermissionService,
    private readonly router: Router,
    private readonly authFacade: AuthFacade,
  ) {

    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.alertCtrl?.dismiss();
        this.showAlertInfoHandler?.dismiss();
      }
    });
  }

  ngOnInit() {
    this.wagerFacade.getSelectEventTrackRaceEntities$()
      .subscribe((allEventTrackRace: Dictionary<IGetEventsDetailsResponse>) => {
        if (_.isEmpty(allEventTrackRace)) return;

        const result = _.chain(allEventTrackRace)
          .filter(item => item?.ToteResponse.EventDetail.EventStatus === 'Finished')
          .sortBy(item => new Date(item?.ToteResponse.EventDetail.EventTime || 0))
          // .map(item => ({
          //   currentRace: _.find(item?.ToteResponse.EventDetail.Races, 'Current')
          // }))
          .last()
          .value();

        this.selectedEvent = result;
      });
  }

  showLatestFinishedEvent(): void {
    if (this.selectedEvent === undefined) return;

    this.wagerFacade.setLatestFinishedEvent(this.selectedEvent);
    this.modalCtrl.dismiss();
  }

  cancel(): void {
    this.modalCtrl.dismiss();
  }

  close(): void {
    this.modalCtrl.dismiss();
  }

  selectResults(method: string): void {
    // console.log('method:', method)

    if (!this.hasPermission() && method === 'replays') {

      // encase
      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('You are not an Identified User.');
      }

      return;
    }

    const resultsSection = this.elementRef.nativeElement.querySelector(
      '.my-results-section'
    );
    // console.log('results: resultsSection:', resultsSection);

    const showCard = this.elementRef.nativeElement.querySelector(
      '.my-results-section .' + method + '.card-content'
    );
    // console.log('results: showCard:', showCard);
    // console.log('results: showCard:', '.my-results-section .' + method + '.card-content');

    const resultsRow = this.elementRef.nativeElement.querySelectorAll(
      '.my-results-section .results-row'
    );
    // console.log('results: resultsRow:', resultsRow);


    const openChev = this.elementRef.nativeElement.querySelector(
      '.my-results-section .' + method + '.results-row .open-chev'
    );
    const closeChev = this.elementRef.nativeElement.querySelector(
      '.my-results-section .' + method + '.results-row .close-chev'
    );

    // open arrow
    if (closeChev.classList.contains('active-chev')) {
      // console.log('OPEN')
      resultsSection.classList.add('active');
      closeChev.classList.remove('active-chev');
      openChev.classList.add('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (cardContent: HTMLElement) => {
        cardContent.classList.add('card-hide');
      });

      // show showCard
      showCard.classList.remove('card-hide');

      resultsRow.forEach((row: HTMLElement) => {
        row.classList.add('card-hide');

        if (row.dataset['name'] === showCard.dataset['name']) {
          row.classList.remove('card-hide');
        }
      });

      (this.controller as any)[method] = true;

    }
    // close arrow
    else {
      // console.log('CLOSE')
      resultsSection.classList.remove('active');
      closeChev.classList.add('active-chev');
      openChev.classList.remove('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (html: HTMLElement) => {
        html.classList.add('card-hide');
      });

      // show all
      resultsRow.forEach((row: HTMLElement) => {
        row.classList.remove('card-hide');
      });

      (this.controller as any)[method] = false;
    }
  }

  hasPermission(): boolean {
    if (this.permissionService.isAllowed()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  async showAlertInfo(message: string): Promise<void> {
    this.showAlertInfoHandler = await this.alertCtrl.create({
      header: 'Info',
      message,
      buttons: [
        {
          text: 'Close',
          handler: () => {
          }
        }
      ]
    });

    await this.showAlertInfoHandler.present();
  }

}
